import { TranslateFunc } from '@ha/intl';

export function getPageTitle(
  T: TranslateFunc,
  typeLabel: string,
  cityStreet: string,
  id: number,
): string {
  return T(
    '%s for rent in %s | HousingAnywhere (%s)',
    typeLabel,
    cityStreet,
    id,
  );
}
